var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 358.9 539.7",
    style: {
      enableBackground: "new 0 0 358.9 539.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#Rectangle_84_00000079457744875722713460000000044570039155798683_);}\n\t.st1{opacity:5.200000e-02;enable-background:new    ;}\n\t.st2{fill:none;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:7;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-linecap:round;}\n\t.st6{opacity:0.112;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{enable-background:new    ;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;}\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:5;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(-288.019 -2311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_227_1",
    transform: "translate(288.019 2311)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_84_00000008857333977315152530000015225897409355275689_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.6363,
    y1: 663.1362,
    x2: -31.7644,
    y2: 665.2429,
    gradientTransform: "matrix(261.31 0 0 -393 8827.1953 261122.2656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3BBB9C",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    style: {
      stopColor: "#08B3D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#25AAE2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    style: {
      fill: "url(#Rectangle_84_00000008857333977315152530000015225897409355275689_)"
    },
    width: 358.9,
    height: 539.7
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YoureSureIcon",
    transform: "translate(47.31 31.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(0 107)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    className: "st1",
    cx: 125.5,
    cy: 316.7,
    rx: 92.7,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28",
    transform: "translate(0.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 125.5,
    cy: 159.4,
    r: 107.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 125.5,
    cy: 159.4,
    r: 103
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    className: "st4",
    cx: 176.2,
    cy: 150.1,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    className: "st4",
    cx: 77.4,
    cy: 150.1,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    transform: "translate(28.464 50.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    className: "st5",
    x1: 150.5,
    y1: 46.8,
    x2: 167.7,
    y2: 57.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    className: "st5",
    x1: 28.3,
    y1: 57.8,
    x2: 45.5,
    y2: 46.8
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    className: "st6",
    cx: 131.7,
    cy: 164.2,
    r: 94.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    className: "st5",
    x1: 121.2,
    y1: 215.7,
    x2: 129.7,
    y2: 215.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(75.75)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.6,71.1l-2-29.6c-0.4-5.8-0.6-9.9-0.6-12.4c0-3.4,0.9-6.1,2.7-8s4.1-2.9,7.1-2.9c3.5,0,5.9,1.2,7.1,3.7 c1.2,2.4,1.8,6,1.8,10.6c0,2.7-0.1,5.5-0.4,8.3l-2.7,30.4c-0.3,3.6-0.9,6.4-1.9,8.3c-0.9,1.9-2.5,2.9-4.7,2.9 c-2.2,0-3.8-0.9-4.6-2.8C52.6,77.7,52,74.9,51.6,71.1z M58.5,111.7c-2.5,0-4.7-0.8-6.6-2.4c-1.9-1.6-2.8-3.9-2.8-6.8 c0-2.5,0.9-4.7,2.7-6.5s4-2.7,6.6-2.7c2.6,0,4.8,0.9,6.6,2.7c1.8,1.8,2.7,4,2.7,6.5c0,2.9-0.9,5.1-2.8,6.8 C63.1,110.8,60.9,111.7,58.5,111.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exclaimation",
    transform: "translate(-78.596 68.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    transform: "translate(-2 -5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    className: "st8",
    x1: 34.1,
    y1: 64.1,
    x2: 34.1,
    y2: 91.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    className: "st8",
    x1: 6.3,
    y1: 64.1,
    x2: 34.1,
    y2: 64.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    className: "st8",
    x1: 6.3,
    y1: 36.3,
    x2: 6.3,
    y2: 64.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    className: "st8",
    x1: 228.4,
    y1: 76.5,
    x2: 203.6,
    y2: 89.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    className: "st8",
    x1: 215.8,
    y1: 51.7,
    x2: 228.4,
    y2: 76.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    className: "st8",
    x1: 240.5,
    y1: 39.1,
    x2: 215.8,
    y2: 51.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    transform: "translate(166.442 52.686)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21-2",
    className: "st8",
    x1: 98.4,
    y1: 57,
    x2: 78.7,
    y2: 76.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22-2",
    className: "st8",
    x1: 78.7,
    y1: 57,
    x2: 98.4,
    y2: 76.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_33",
    transform: "translate(16.536 -53)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 37.2,
    cy: 32,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 37.2,
    cy: 32,
    r: 11
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClash);
export default __webpack_public_path__ + "static/media/clash.94b9a8ec542d04b65e7115f8063e9531.svg";
export { ForwardRef as ReactComponent };